import React from "react";

const Ban = () => (
  <path
    d="M10 2.5C5.85786 2.5 2.5 5.85786 2.5 10C2.5 14.1421 5.85786 17.5 10 17.5C14.1421 17.5 17.5 14.1421 17.5 10C17.5 5.85786 14.1421 2.5 10 2.5ZM4 10C4 8.68531 4.42281 7.46938 5.14031 6.48031L13.5197 14.8597C12.5306 15.5772 11.3147 16 10 16C6.68629 16 4 13.3137 4 10ZM14.8597 13.5197L6.48031 5.14031C7.46938 4.42281 8.68531 4 10 4C13.3137 4 16 6.68629 16 10C16 11.3147 15.5772 12.5306 14.8597 13.5197Z"
    fill="currentColor"
  />
);

export default Ban;
